type GetBopisData = {
    storeId: string;
};

export const getBopisData = ({ storeId }: GetBopisData) => {
    return { storeId };
};
